﻿import { sqlQuery } from '@/shared/helpers/api.ts';
import { http } from '@/shared/httpWrapper';

export type FacilityPublishEligibility = {
    identity: string;
    description: string;
    isForStid: boolean;
    isForTie: boolean;
};

export async function getFacilityPublishEligibilityList(): Promise<FacilityPublishEligibility[]> {
    return (await sqlQuery(http, { query: `
            SELECT
                [Identity] [identity],
                [Description] [description],
                [IsForSTID] [isForStid],
                [IsForTIELibraryPublish] [isForTie]
            FROM Facility
            WHERE IsValid = 1 AND (IsForSTID = 1 OR IsForTIELibraryPublish = 1)`
    })).data as FacilityPublishEligibility[];
}
